import { doc } from 'firebase/firestore';
import { docData } from 'rxfire/firestore';
import { Observable } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { IKeyMetricsMap, IUser } from '../../types';
import { authenticatedUserProvider } from '../userProvider';

/**
 * @description observes key metrics settings
 */

export const keyMetricsSettingsProvider = (): Observable<IKeyMetricsMap> => {
  return authenticatedUserProvider().pipe(
    switchMap((user: IUser): Observable<IKeyMetricsMap> => {
      return docData(
        doc(
          user.services.firestore,
          `userProfiles/${user.id}/settings/keyMetrics`
        )
      );
    })
  );
};
